// extracted by mini-css-extract-plugin
module.exports = {"root":"FailureStep_root__1i7CF","pic":"FailureStep_pic__2bfgo","header":"FailureStep_header__3WRWJ","text":"FailureStep_text__mD5fd","actions":"FailureStep_actions__356Db"};